import {
  Box,
  Button,
  Paper,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { GridRowModes, DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import AssignmentIcon from "@mui/icons-material/Assignment";
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import * as services from "../../services/services";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import SearchIcon from "@mui/icons-material/Search";

const PetList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const keyword = searchText.toLowerCase();

  const filtered = rows.filter(
    (p) =>
      p.petName.toLowerCase().includes(keyword) ||
      p.petCode?.toLowerCase().includes(keyword) ||
      p.hospitalPetCode?.toLowerCase().includes(keyword),
  );

  const columns = [
    { field: "no", headerName: "No", flex: 0.5 },
    { field: "serviceDate", headerName: "วันที่เข้ารับบริการ", flex: 1 },
    { field: "serviceType", headerName: "บริการที่เข้ารับ", flex: 2 },
    { field: "hospitalPetCode", headerName: "IDสัตว์เลี้ยง", flex: 1.5 },
    { field: "bowID", headerName: "BOW ID", flex: 1.5 },
    { field: "petName", headerName: "ชื่อสัตว์เลี้ยง", flex: 2 },
    { field: "petType", headerName: "ชนิดสัตว์เลี้ยง", flex: 1 },
    { field: "Breed", headerName: "สายพันธุ์", flex: 2 },
    {
      field: "detail",
      headerName: "รายละเอียด",
      flex: 1,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center", // กึ่งกลางแนวนอน
            alignItems: "center", // กึ่งกลางแนวตั้ง
            width: "100%",
            height: "100%",
          }}
        >
          <AssignmentIcon
            style={{ color: "#1976d2", cursor: "pointer" }}
            onClick={() => {
              navigate(`/medical_history/${params.row.id}`, {
                state: params.row,
              });
            }}
          />
        </div>
      ),
    },
  ];
  const fetchHistory = useCallback(async () => {
    const res = await services.getHistory();
    const rawData = res.data.data;
    const productsWithIndex = rawData.map((item, index) => ({
      ...item,
      no: index + 1,
      petID: item.pet.id,
      bowID: item.pet.petCode,
      hospitalPetCode: item.pet.hospitalPetCode,
      petName: item.pet.name,
      petType: item.pet.type,
      Breed: item.pet.breed,
      owner:
        item.pet.owner === null
          ? "ไม่มีเจ้าของ"
          : item.pet.owner.firstName + " " + item.pet.owner.lastName,
      serviceType:
        item.serviceType === "vaccine"
          ? "ฉีดวัคซีน"
          : item.serviceType === "parasite"
            ? "ป้องกันพยาธิ"
            : "ฝังไมโครชิพ",
      serviceDate: formatDate(item.serviceDate),
    }));

    setRows(productsWithIndex);
    setLoading(false);
  }, []);
  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-GB");
  };

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  return (
    <>
      <AppBreadcrumbs />
      <Toaster position="bottom-left" reverseOrder={false} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: 2,
          my: 2,
        }}
      >
        {/* ส่วนซ้าย: หัวข้อ + Search */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: 2,
            flex: 1,
            minWidth: 0,
          }}
        >
          <Typography component="h2" variant="h5" sx={{ whiteSpace: "nowrap" }}>
            รายการสัตว์เลี้ยง
          </Typography>
          <TextField
            fullWidth
            label="ค้นหา"
            placeholder="ชื่อสัตว์ / Pet ID"
            variant="outlined"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{ maxWidth: { xs: "100%", sm: 420 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>

      <Box sx={{ flex: 1, position: "relative" }}>
        <Box sx={{ position: "absolute", inset: 0 }}>
          <Paper>
            <DataGrid rows={filtered} columns={columns} loading={loading} />
          </Paper>
        </Box>
      </Box>
    </>
  );
};

export default PetList;
